module.exports = "/packs/images/social/auto-ship-e029aea1f5507f36dce52aec47e7544c.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/social/auto-ship.jpg
// module id = 1810
// module chunks = 0